"use client";
import { convertImage, toBase64 } from "@/utils/functions/Images-functions";
import Image from "next/image";
import PictureMobile from "./PictureMobile";
import { useIsMobile } from "@/hooks/useIsMobile";

interface props {
  src: string;
  mobile_src: string;
  alt?: string;
  priority?: boolean;
}
const Picture: React.FC<props> = ({ src, mobile_src, alt, priority }) => {
  const mobile = useIsMobile();

  return mobile ? (
    <PictureMobile alt={alt} mobile_src={mobile_src} priority={priority} />
  ) : (
    <Image
      fetchPriority={priority ? "high" : undefined}
      loading={priority ? "eager" : "lazy"}
      src={src}
      alt={alt || "slider"}
      placeholder={"blur"}
      blurDataURL={`data:image/svg+xml;base64,${toBase64(
        convertImage(10, 10),
      )}`}
      sizes="1440px"
      fill
      className="img-pc"
      objectFit="fill"
      priority={priority}
    />
  );
};

export default Picture;
